// extracted by mini-css-extract-plugin
module.exports = {"defaultFeedback":"styles_defaultFeedback__2hAdT","positiveFeedbackButton":"styles_positiveFeedbackButton__2jD8L","negativeFeedbackButton":"styles_negativeFeedbackButton__3dpYs"};